<template>
  <div class="tw-mt-8 md:tw-mt-10 tw-flex tw-items-center tw-justify-center tw-gap-x-1">
    <QBtn
      flat
      :disable="page === 1"
      class="pagination-btn-prev-custom tw-title-04 tw-text-description"
      @click="page--"
    >
      {{ $t('components.pagination.prev') }}
    </QBtn>
    <div :class="['pagination-custom', { 'pagination-rounded': props.rounded }]">
      <QPagination
        v-model="page"
        :max="totalPages"
        :max-pages="props.maxPages"
        flat
        color="grey"
        active-color="transparent"
        gutter="4px"
        size="16px"
      />
    </div>
    <QBtn
      flat
      :disable="page === totalPages"
      class="pagination-btn-next-custom tw-title-04 tw-text-description"
      @click="page++"
    >
      {{ $t('components.pagination.next') }}
    </QBtn>
  </div>
</template>

<script setup lang="ts">
import { QBtn } from 'quasar'

const props = defineProps({
  rounded: {
    type: Boolean,
    default: false,
  },
  maxPages: {
    type: Number,
    default: 6,
  },
  total: {
    type: Number,
    required: true,
  },
  perPage: {
    type: Number,
    required: true,
  },
})

const totalPages = computed(() => {
  return Math.ceil(props.total / props.perPage)
})

const page = defineModel<number>({
  default: 1,
})
</script>
